export const payModes = {
    CARD: 'stripe',
    IDEAL: 'ideal',
    BANK_TRANSFER: 'bank-transfer',
    MERCADO_PAGO: 'mercado-pago',
    P24: 'p24'
}

const stripeAppearanceVariables = {
    www: {
        borderRadius: '30px',
        colorBackground: '#252336',
        colorPrimary: '#1867FF',
        colorPrimaryText: '#1A1B25',
        colorText: 'white',
        colorTextSecondary: 'white',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
        fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
    },
    ocisport: {
        borderRadius: '10px',
        colorBackground: '#ffffff',
        colorPrimary: '#ED7203',
        colorPrimaryText: '#1A1B25',
        colorText: '#100F23',
        colorTextSecondary: '#6e6d6d',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
    },
    webshow: {
        borderRadius: '10px',
        colorBackground: '#f4f4f4',
        colorPrimary: '#F49739',
        colorPrimaryText: '#1A1B25',
        colorText: '#100F23',
        colorTextSecondary: '#6e6d6d',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
    },
    carnival: {
        borderRadius: '10px',
        colorBackground: '#ffffff',
        colorPrimary: '#009EB3',
        colorPrimaryText: '#1A1B25',
        colorText: '#100F23',
        colorTextSecondary: '#6e6d6d',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
    },
    transgrancanaria: {
        borderRadius: '10px',
        colorBackground: '#ffffff',
        colorPrimary: '#0C9CD3',
        colorPrimaryText: '#1A1B25',
        colorText: '#100F23',
        colorTextSecondary: '#6e6d6d',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
    },
    bluserena: {
        borderRadius: '4px',
        colorBackground: '#FAFAFA',
        colorPrimary: '#0066FF',
        colorPrimaryText: '#1A1B25',
        colorText: '#100F23',
        colorTextSecondary: '#6e6d6d',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
    },
    costa: {
        borderRadius: '4px',
        colorBackground: '#F3F4F5',
        colorPrimary: '#111',
        colorPrimaryText: '#111',
        colorText: '#111',
        colorTextSecondary: '#6e6d6d',
        colorTextPlaceholder: '#8f8f9d',
        focusBoxShadow: 'none',
    },
}

export function getAppearanceVariables(domain) {
    return stripeAppearanceVariables[domain] || stripeAppearanceVariables.www
}
